import WishlistShareSection from './wishlist-share-section'
export default WishlistShareSection
